import { twMerge } from 'tailwind-merge';

import Text from './Text';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { ComponentProps, ReactNode } from 'react';

type IconWithTextProps = {
  icon: ReactNode;
  text: string;
  className?: Pick<ClassNameComponent, 'base' | 'text'>;
  href?: string;
} & Omit<ComponentProps<'div'>, 'className'>;

export function IconWithText({
  icon,
  text,
  className,
  href,
  ...props
}: IconWithTextProps) {
  return (
    <div
      className={twMerge(
        'flex flex-row self-start items-center gap-2.5',
        className?.base,
      )}
      {...props}
    >
      {icon}
      <Text
        href={href}
        text={text}
        className={twMerge('text-16 font-500', className?.text)}
      />
    </div>
  );
}
